export function isNullOrUndefined(value: unknown): boolean {
  return value === null || value === undefined;
}

export function isObject(value: unknown): boolean {
  return value !== null && typeof value === 'object';
}

export function isNumber(value: unknown): boolean {
  return typeof value === 'number';
}

export function isNull(value: unknown): boolean {
  return value === null;
}

export function isString(value: unknown): boolean {
  return typeof value === 'string';
}
